import { CrudServiceBase } from './CrudServiceBase';
import { PhaseAliasDto } from '@/models/PhaseAliasDto';

export class PhaseAliasService extends CrudServiceBase<PhaseAliasDto> {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  async getAll(filterOut: Guid[]  = []) : Promise<PhaseAliasDto[]> {
    return await this.client.getPostData(`/all`, filterOut);
  }
}